export default {
  productDetailsForm: null,
  vendorTiers: [],
}
